module.exports = new __parcel__URL__("dashboards-empty.ed2e5362.svg").toString();